import { Flex, FloraTypography } from '@grupoboticario/flora-react'

import { parseDatetime } from '@/utils/format/parseDatetime'
import { getTierLabel } from '@/utils/getTierLabel'

import CashbackByBrand from './components/CashbackByBrand/CashbackByBrand'
import * as S from './ExtractDetailsWithCashback.styles'

const getColor = (hasColor, value, isBlocked) => {
  if (isBlocked || value < 0) return '$error-standard'
  if (!hasColor) return '$nonInteractivePredominant'

  return '$linkDefault'
}

const getMemberDetails = ({ expirationDate, lastTransactionPoints, tier }) => [
  {
    title: 'Última transação',
    value: lastTransactionPoints.toLocaleString('pt-BR'),
    hasColor: true
  },
  {
    title: 'Próxima validade',
    value: expirationDate
      ? new Date(parseDatetime(expirationDate)).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        })
      : '-',
    hasColor: false
  },
  {
    title: 'Tier atual',
    value: getTierLabel(tier),
    hasColor: false
  }
]

const ExtractDetailsWithCashback = ({
  expirationDate,
  lastTransactionPoints,
  tier,
  totalPoint,
  totalCashback,
  totalLoyalty
}) => {
  const memberDetails = getMemberDetails({ expirationDate, lastTransactionPoints, tier })
  return (
    <Flex css={S.summaryCss} direction="column" gap="$4">
      <CashbackByBrand totalCashback={totalCashback} totalLoyalty={totalLoyalty} totalPoint={totalPoint} />

      <Flex css={S.detailsRowCss} gap="$4">
        {memberDetails.map((info) => (
          <Flex css={S.cardCss} direction="column" gap="$2" justify="center" key={info.title}>
            <FloraTypography fontWeight="medium" fontSize="exceptionsAuxiliar">
              {info.title}
            </FloraTypography>
            <Flex align="baseline" gapX="$1">
              <FloraTypography
                as="h6"
                css={S.getDynamicColorCss(getColor(info.hasColor, info.value, info.isBlocked))}
                fontSize="subtitle"
              >
                {info.value}
              </FloraTypography>
              {!!info.isBlocked && (
                <FloraTypography css={S.errorTextCss} fontSize="exceptionsAuxiliar">
                  (bloqueado)
                </FloraTypography>
              )}
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

export default ExtractDetailsWithCashback
